import $ from "jquery"
import _ from "underscore"
import BasicLightbox from "../../BasicLightbox"

const BaseReportPDFPreviewLightbox = function() {};

BaseReportPDFPreviewLightbox.prototype = _.create(BasicLightbox.prototype, {
    exist_invalid_fields_message_key: "",
    close_tab_confirmation_message_key: "",

    init: function( config )
    {
        BasicLightbox.prototype.init.call(this, config.popupId, config.closeBtnId);

        var self = this;
        this.titleEl = $(this.lightBoxEl).find(".lightBoxTitle");
        this.setCancelCallback( function() { self.hide(); } );
        this.eventNamespace = config.eventNamespace;

        this.pdfPreviewViewController = this.createPDFLightboxController({
            lightBoxEl: this.lightBoxEl,
            titleEl: this.titleEl,
            popupId: config.popupId,
            eventNamespace: config.eventNamespace,
        })

        return this;
    },
    
    createPDFLightboxController: function({lightBoxEl, titleEl, popupId, eventNamespace})
    {
        //abstract    
    },

    show: function()
    {
        BasicLightbox.prototype.show.call(this);
        this.pdfPreviewViewController.onShow();
        $(document).trigger(this.eventNamespace + ".pdfPreview.lightbox.show");
    },

    hide: function ()
    {
        $(document).trigger(this.eventNamespace + ".pdfPreview.lightbox.hide");
        BasicLightbox.prototype.hide.call(this);
    },

    cancelAllExportingProcesses: function ()
    {
        this.pdfPreviewViewController.cancelAllExportingProcesses();
    }
});

export default BaseReportPDFPreviewLightbox


// WEBPACK FOOTER //
// ./web/js/reports/pdf/PDFPreviewLightbox.js